var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: this.$t("CargoMsg.Cargo_Distribution"),
            width: "380px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_Acquirer") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "recipientId",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId
                          },
                          "merge-load": true
                        },
                        on: {
                          change: function(item) {
                            return (_vm.recipientId = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }